export const token = localStorage.getItem("beautyToken");
export const refreshToken = localStorage.getItem("beautyRefreshToken");

export const setToken = (token) => {
    localStorage.setItem("beautyToken", token)
}

export const setRefreshToken = (token) => {
    localStorage.setItem("beautyRefreshToken", token)
}